import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const blocksApi = createApi({
  reducerPath: 'blocksApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getBlocksWithEdit: builder.query({
      query() {
        return {
          url: `${urls.blocks}?edit=true`,
          method: 'GET',
        };
      },
    }),
    getBlocksWithEnglishParameter: builder.query({
      query: (isEnglish) => ({
        url: `${urls.blocks}?english=${isEnglish}`,
        method: 'GET',
      }),
    }),
    getBlocks: builder.query({
      query() {
        return {
          url: `${urls.blocks}`,
          method: 'GET',
        };
      },
    }),
    getBlockDetail: builder.query({
      query(id) {
        return {
          url: urls.blockDetail(id),
          method: 'GET',
        };
      },
    }),
    saveBlock: builder.mutation({
      query(req) {
        const data = req.data.generated_content
          ? req.data
          : { ...req.data, generated_content: 0 };
        if (req.id) {
          return {
            url: urls.blockDetail(req.id),
            method: 'PUT',
            data: data,
          };
        } else {
          return {
            url: urls.blocks,
            method: 'POST',
            data: data,
          };
        }
      },
    }),
    saveBlocksOrder: builder.mutation({
      query(req) {
        return {
          url: urls.blocksOrder,
          method: 'POST',
          data: {
            items: [
              ...req.items.map((item) => ({
                block_id: item.id,
              })),
            ],
            isEnglish: req.isEnglish,
          },
        };
      },
    }),
    deleteBlock: builder.mutation({
      query(id) {
        return {
          url: urls.blockDetail(id),
          method: 'DELETE',
        };
      },
    }),
  }),
});

export const {
  useGetBlocksWithEditQuery,
  useGetBlocksWithEnglishParameterQuery,
  useGetBlocksQuery,
  useGetBlockDetailQuery,
  useSaveBlockMutation,
  useSaveBlocksOrderMutation,
  useDeleteBlockMutation,
} = blocksApi;
